<template>
  <div class="app-view-personal-data">
    <slot name="beforePersonalData">Persönliche Daten</slot>
    <ShowPersonalData
      :customer="currentCustomer"
      :view-phone="true"
    >
      <template v-for="slot in possibleChildSlotsFor('PersonalData')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowPersonalData>
    <slot name="beforePhonebookData"></slot>
    <ShowPhonebookData  :customer="currentCustomer">
      <template v-for="slot in possibleChildSlotsFor('Phone')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowPhonebookData>
    <ShowEvnData :currentEvnConfiguration="currentEvnConfiguration">
      <template v-for="slot in possibleChildSlotsFor('Evn')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowEvnData>
    <slot name="afterPersonalData"></slot>
    <Stepper
      @next="nextView()"
      :show-prev="false"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import ShowPersonalData from '@/components/process/generic/PersonalData/ShowPersonalData.vue'
import Stepper from '@/components/generic/Stepper.vue'
import slotProxy from '@/mixins/slotProxy'
import ShowPhonebookData from '@/components/process/generic/Phonebook/ShowPhonebookData.vue'
import ShowEvnData from '@/components/process/generic/ItemisedBills/ShowEvnData.vue'

export default {
  name: 'ViewPersonalData',
  components: { ShowEvnData, ShowPhonebookData, ShowPersonalData, Stepper },
  methods: {
    ...mapMutations('personalData', [
      'changeView'
    ]),
    nextView () {
      this.changeView('changePersonalData')
    }
  },
  mixins: [
    slotProxy()
  ],
  props: {
    currentCustomer: {
      type: Object
    },
    currentEvnConfiguration: {
      type: Object
    }
  }
}
</script>
